<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link class="navbar-brand" to="/">
          <span class="brand-logo">
            <b-img
              :src="logoPreviewUrl"
              alt="logo"
              referrerpolicy="no-referrer"
              @error="onLogoPreviewError"
            />
          </span>
          <h2 class="brand-text mb-0">
            {{ appName }}
          </h2>
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from "bootstrap-vue";
import { $themeConfig } from "@themeConfig";
import { getMediaPreviewUrl, handleDrivePreviewError } from "@/utils/gdriveUpload";

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app;
    return {
      appName,
      appLogoImage,
    };
  },
  computed: {
    logoPreviewUrl() {
      const url =
        this.$store.state.appConfig.appLogoImage || this.appLogoImage;
      if (!url) return "";
      if (String(url).startsWith("blob:")) return url;
      return getMediaPreviewUrl(url, "Image");
    },
  },
  methods: {
    onLogoPreviewError(event) {
      const url =
        this.$store.state.appConfig.appLogoImage || this.appLogoImage;
      if (!url) return;
      handleDrivePreviewError(event, url, "image");
    },
  },
};
</script>

<style></style>
